module.exports = __webpack_public_path__ + "static/media/fleshHaut.8b617329.svg";